﻿import {$$, Key} from "@/Utils";

function setSelectedListItem(dropdown: HTMLElement, item: HTMLElement, dispatch: boolean, close = false) {
    if (dropdown.closest(".locked")) {
        return
    }
    const isListItem = item && (item.classList.contains("dropdown__list-item") || item.classList.contains("in-item"))

    let isOpen = dropdown.classList.contains("open");
    if (!isListItem || item.classList.contains("disabled")) {
        dropdown.classList.toggle("open", close ? false : undefined)
        isOpen = !isOpen
        dropdown.setAttribute("aria-expanded", String(isOpen))
        return
    }
    
    if (close && !dispatch && !isOpen) {
        return
    }

    const relatedHidden = dropdown.previousElementSibling as HTMLInputElement //EditorTemplates/Dropdown.cshtml
    const dropdownSelectedNode = dropdown.querySelector(".dropdown__selected") as HTMLElement
    const items = dropdown.querySelectorAll(".dropdown__list-item")
    
    items.forEach((i: Element) => {
        i.classList.toggle("dropdown__list-item--active", item === i)
        i.setAttribute("aria-selected",item === i ? "true" : "false")
    })
    item.scrollIntoView({behavior: 'smooth', block: 'nearest'})
    if (dispatch) {
        dropdown.classList.remove("open")
    }
    
    const selectedValue = item.getAttribute("value")

    if (relatedHidden) {
        relatedHidden.value = selectedValue
        relatedHidden.dispatchEvent(new Event("input"))
        relatedHidden.dispatchEvent(new Event("change"))
    }
    
    dropdownSelectedNode.classList.add("dropdown__selected--active");

    const hasDataText = item.hasAttribute("data-text")
    dropdownSelectedNode.querySelector("[data-text]").innerHTML = hasDataText ? item.getAttribute("data-text") : item.innerHTML
    if (hasDataText) {
        dropdownSelectedNode.setAttribute("aria-label", item.innerHTML)
    }

    if (dispatch && selectedValue) {
        const event = new CustomEvent("valueChange", {detail: {value: selectedValue}})
        item.closest(".dropdown").dispatchEvent(event);
    }
}

export function triggerDropdownClick(item: HTMLElement, dispatch: boolean, items?: NodeListOf<Element>) {
    items ??= item.parentNode.querySelectorAll(".dropdown__list-item");
    const dropdown = items[0].closest(".dropdown") as HTMLElement;
    if (item.querySelector("input")?.disabled) {
        return;
    } else {
        setSelectedListItem(dropdown, item, dispatch);
    }
}

export function initDropdowns() {
    const listItems = new Array<NodeListOf<Element>>();

    $$(".dropdown").forEach((dd: Element) => {
        listItems.push(dd.querySelectorAll(".dropdown__list-item:not(.disabled)"));
        dd.addDataBoundEventListener("click", (e: Event) => {
            const dropdown = e.currentTarget as HTMLElement
            let item = e.target as HTMLElement
            if(item.classList.contains("in-item"))
                item = item.parentElement
            setSelectedListItem(dropdown, item, true)
        });
    });
    document.body.addDataBoundEventListener("keydown", (e: KeyboardEvent) => {
        const dropdownSelected = document.activeElement
        if (!dropdownSelected.classList.contains("dropdown__selected")) return
        const dropdown = dropdownSelected.parentElement as HTMLElement
        const isOpen = dropdown.classList.contains("open")
        let item = (dropdown.querySelector(".dropdown__list-item--active") || dropdown.querySelector(".dropdown__list-item")) as HTMLElement
        const toggleOpen = e.altKey && (e.key === Key.ArrowUp || e.key === Key.ArrowDown)
        if (toggleOpen || e.key === Key.Space || e.key === Key.SpaceAlt || e.key === Key.Enter) {
            e.preventDefault()
            if (!isOpen) {
                closeOtherDropdowns(dropdown, $$(".dropdown"))
            }
            const newItem = dropdown.querySelector(".dropdown__list-item--active, [aria-selected='true']") as HTMLElement
            setSelectedListItem(dropdown, toggleOpen ? null : newItem, true, e.key === Key.Enter)
        } else if (e.key === Key.ArrowUp || e.key === Key.ArrowDown) {
            e.preventDefault()
            do {
                item = (e.key === Key.ArrowUp ? item.previousElementSibling : item.nextElementSibling) as HTMLElement
            } while (item && item.classList.contains("disabled"))
            if (item) {
                setSelectedListItem(dropdown, item, false)
            }
        } else if (e.key === Key.Tab) {
            setSelectedListItem(dropdown, item, true, true)
        }
    })
}

export function closeOtherDropdowns(targetDropdown: Element, dropdowns: NodeListOf<Element>) {
    dropdowns.forEach((dropdown: HTMLElement) => {
        if (dropdown !== targetDropdown) {
            const item = (dropdown.querySelector(".dropdown__list-item--active") || dropdown.querySelector(".dropdown__list-item")) as HTMLElement
            setSelectedListItem(dropdown, item, false, true);
        }
    });
}